(ns common.patterns.loading-view
  (:require ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Stack$default" :as Stack]
            [uix.core :refer [$ defui]]))

(defui loading-view [{:keys [children] :as props}]
  ($ Stack
     (merge {:justifyContent "center"
             :alignItems "center"
             :spacing 1
             :flex 1}
            props)
     ($ CircularProgress)
     children))
